function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7315 19.1651L19.2521 16.3702L22.7272 12.983C22.8746 12.8392 22.9277 12.6242 22.864 12.4284C22.8004 12.2327 22.6311 12.0899 22.4275 12.0603L17.6251 11.3626L15.4774 7.01091C15.3863 6.82634 15.1983 6.70945 14.9924 6.70945C14.7866 6.70945 14.5985 6.82634 14.5075 7.01091L12.3598 11.3626L7.55756 12.0603C7.35389 12.09 7.18455 12.2327 7.12098 12.4284C7.0574 12.6242 7.11043 12.8392 7.25785 12.983L10.7329 16.3702L9.9125 21.153C9.87775 21.3559 9.96113 21.561 10.1278 21.682C10.2942 21.803 10.5151 21.819 10.6974 21.7232L14.9926 19.4651L19.2879 21.7232C19.367 21.7649 19.4534 21.7853 19.5396 21.7853C19.6516 21.7853 19.7633 21.7504 19.8575 21.682C20.0242 21.561 20.1076 21.3558 20.0729 21.153L19.7315 19.1651Z",
  fill: "#1442A8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.552 2.53359C10.5239 2.44681 10.4488 2.38353 10.3586 2.37052L8.23114 2.06132L7.27964 0.133593C7.23927 0.0517382 7.15601 0 7.06478 0C6.97355 0 6.89029 0.0517382 6.84992 0.133593L5.89842 2.06132L3.77088 2.37052C3.68071 2.38365 3.60565 2.44681 3.57747 2.53359C3.54934 2.62025 3.57284 2.71546 3.63811 2.77915L5.1776 4.27974L4.81414 6.39872C4.79873 6.4886 4.83565 6.57936 4.90947 6.63303C4.9833 6.68665 5.08115 6.69374 5.16184 6.65126L7.06472 5.65089L8.96755 6.65126C9.00259 6.66966 9.04096 6.6788 9.07911 6.6788C9.12874 6.6788 9.17819 6.66333 9.21997 6.63303C9.29368 6.57942 9.33065 6.48854 9.31536 6.39872L8.95184 4.27968L10.4913 2.77915C10.5567 2.71546 10.5802 2.62031 10.552 2.53359Z",
  fill: "#1442A8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6052 26.8945C17.5841 26.8296 17.5278 26.7822 17.4603 26.7724L15.8664 26.5408L15.1536 25.0966C15.1235 25.0353 15.061 24.9965 14.9927 24.9965C14.9244 24.9965 14.862 25.0353 14.8318 25.0966L14.1191 26.5408L12.5252 26.7724C12.4576 26.7822 12.4013 26.8296 12.3802 26.8945C12.3591 26.9595 12.3767 27.0309 12.4256 27.0786L13.579 28.2028L13.3067 29.7901C13.2952 29.8574 13.3228 29.9255 13.378 29.9657C13.4333 30.0059 13.5066 30.0111 13.5671 29.9793L14.9926 29.2298L16.4182 29.9793C16.4444 29.9931 16.4731 29.9998 16.5016 29.9998C16.5387 29.9998 16.5761 29.9883 16.6071 29.9656C16.6624 29.9254 16.6901 29.8573 16.6787 29.79L16.4063 28.2027L17.5597 27.0785C17.6088 27.0308 17.6263 26.9595 17.6052 26.8945Z",
  fill: "#1442A8"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M11.6777 20.6285L12.4981 15.8457L9.02307 12.4584C8.87565 12.3147 8.82262 12.0997 8.8862 11.9039C8.89059 11.8904 8.89663 11.8779 8.90202 11.8649L7.55829 12.0602C7.35462 12.0898 7.18528 12.2325 7.12171 12.4283C7.05814 12.624 7.11116 12.8391 7.25858 12.9828L10.7337 16.37L9.91322 21.1529C9.87848 21.3557 9.96186 21.5609 10.1285 21.6819C10.295 21.8029 10.5159 21.8189 10.6981 21.7231L11.8471 21.1189C11.7119 20.9957 11.6464 20.8115 11.6777 20.6285Z",
  fill: "#1442A8"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M6.57875 5.87461L6.94221 3.75563L5.40272 2.25504C5.37061 2.22376 5.34875 2.18479 5.33803 2.14301L3.77094 2.37071C3.68077 2.38383 3.60571 2.447 3.57753 2.53377C3.5494 2.62043 3.5729 2.71565 3.63817 2.77934L5.17766 4.27992L4.8142 6.3989C4.79879 6.48879 4.83571 6.57955 4.90954 6.63322C4.98336 6.68683 5.08121 6.69392 5.1619 6.65144L6.57541 5.90836C6.5757 5.89711 6.57682 5.88586 6.57875 5.87461Z",
  fill: "#1442A8"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M15.0712 29.2655L15.3436 27.6782L14.1902 26.554C14.1697 26.5341 14.1561 26.5095 14.1472 26.4835L14.119 26.5406L12.5251 26.7721C12.4576 26.782 12.4013 26.8294 12.3801 26.8943C12.359 26.9593 12.3767 27.0307 12.4256 27.0784L13.5789 28.2025L13.3066 29.7899C13.2951 29.8572 13.3227 29.9253 13.378 29.9655C13.4333 30.0057 13.5066 30.0109 13.567 29.9791L14.9925 29.2296L15.0709 29.2708C15.0713 29.269 15.0709 29.2673 15.0712 29.2655Z",
  fill: "#1442A8"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4194 19.2412C27.2856 19.2412 27.9879 18.5389 27.9879 17.6727C27.9879 16.8064 27.2856 16.1041 26.4194 16.1041C25.5531 16.1041 24.8508 16.8064 24.8508 17.6727C24.8508 18.5389 25.5531 19.2412 26.4194 19.2412Z",
  fill: "#1442A8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M3.58073 21.7833C4.44701 21.7833 5.14928 21.081 5.14928 20.2147C5.14928 19.3485 4.44701 18.6462 3.58073 18.6462C2.71444 18.6462 2.01218 19.3485 2.01218 20.2147C2.01218 21.081 2.71444 21.7833 3.58073 21.7833Z",
  fill: "#1442A8"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M25.8994 17.673C25.8994 16.9906 26.3352 16.4104 26.9436 16.1946C26.7796 16.1365 26.6032 16.1045 26.4192 16.1045C25.5529 16.1045 24.8507 16.8067 24.8507 17.6731C24.8507 18.5393 25.5529 19.2416 26.4192 19.2416C26.6032 19.2416 26.7796 19.2097 26.9436 19.1515C26.3353 18.9356 25.8994 18.3554 25.8994 17.673Z",
  fill: "#1442A8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M3.06085 20.2143C3.06085 19.532 3.49661 18.9517 4.10499 18.7359C3.94098 18.6777 3.76456 18.6458 3.58063 18.6458C2.71427 18.6458 2.01208 19.348 2.01208 20.2143C2.01208 21.0806 2.71427 21.7829 3.58063 21.7829C3.76456 21.7829 3.94098 21.751 4.10499 21.6928C3.49673 21.477 3.06085 20.8967 3.06085 20.2143Z",
  fill: "#1442A8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4058 6.67937C23.0108 6.67937 23.5012 6.18896 23.5012 5.58402C23.5012 4.97908 23.0108 4.48867 22.4058 4.48867C21.8009 4.48867 21.3105 4.97908 21.3105 5.58402C21.3105 6.18896 21.8009 6.67937 22.4058 6.67937Z",
  fill: "#1442A8"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M24.8512 26.5872C25.4562 26.5872 25.9466 26.0968 25.9466 25.4918C25.9466 24.8868 25.4562 24.3964 24.8512 24.3964C24.2462 24.3964 23.7558 24.8868 23.7558 25.4918C23.7558 26.0968 24.2462 26.5872 24.8512 26.5872Z",
  fill: "#1442A8"
});

var SvgCleaning = function SvgCleaning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCleaning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cleaning.68942123.svg";
export { ForwardRef as ReactComponent };